import { Injectable } from '@angular/core';

// add my services and common stuff here
import * as Constants from 'src/app/services/constants/constants';

@Injectable()
export class BroadcastPush 
{
  consoleLog: boolean = false;
  SurveyRecipientId: number = 0;
  SurveyBroadcastId: number = 0;
  StructuredFormId: number = 0;
  StructuredFormCode: string = "";
  StructuredFormName: string = "";
  StructuredFormMessageLevelCode: string = "";
  StructuredFormMessageText: string = "";
  StructuredFormResponseChoiceCount: string = "";
  StructuredFormResponseListStructuredResponseFormId: string = "";
  StructuredFormResponseListResponseText: string = "";
  MobileMediaCount: string = "";
  MobileMediaListMobileMediaId: string = "";
  NotificationTypeCode: string = "";
  StructuredFormTypeCode:string = ""; // replaces use of legacy MessageTypeCode

  constructor(notificationPayload: any) 
  {
    if (this.consoleLog) console.log('BroadcastPush.ctor - LifeCycle');
    
    if (!notificationPayload) 
    {
      return;
    }
    this.MobileMediaCount = notificationPayload.MobileMediaCount || "";
    this.MobileMediaListMobileMediaId = notificationPayload.MobileMediaListMobileMediaId || "";
    this.SurveyRecipientId = notificationPayload.SurveyRecipientId || "";
    this.SurveyBroadcastId = notificationPayload.SurveyBroadcastId || "";
    this.StructuredFormId = notificationPayload.StructuredFormId || "";
    this.StructuredFormCode = notificationPayload.StructuredFormCode || "";
    this.StructuredFormName = notificationPayload.StructuredFormName || "";
    this.StructuredFormMessageLevelCode = notificationPayload.StructuredFormMessageLevelCode || "";
    this.StructuredFormMessageText = notificationPayload.StructuredFormMessageText || "";
    this.StructuredFormResponseChoiceCount = notificationPayload.StructuredFormResponseChoiceCount || "";
    this.StructuredFormResponseListStructuredResponseFormId = notificationPayload.StructuredFormResponseListStructuredResponseFormId || "";
    this.StructuredFormResponseListResponseText
      = notificationPayload.StructuredFormResponseListResponseText || ""; // contains encoded
    
    // StructuredFormType replaces MessageType
    this.StructuredFormTypeCode = notificationPayload.StructuredFormTypeCode || "";
    if (!this.StructuredFormTypeCode)
    {
      this.StructuredFormTypeCode = notificationPayload.MessageTypeCode; // temporary backwards compatibility (to be removed)
    }


    // StructuredFormType replaces MessageType
    if (this.StructuredFormTypeCode === Constants.NOTIFICATION_TYPE_ACTIONABLE) // notificationPayload.MessageTypeCode
    {
      // special handling for Actionable *until* API returns this in AmbitEventTypeCode instead of SURVEY for both
      this.NotificationTypeCode = Constants.NOTIFICATION_TYPE_ACTIONABLE; // instead of SURVEY
    }
    else if (this.StructuredFormTypeCode === Constants.NOTIFICATION_TYPE_SURVEY) // notificationPayload.MessageTypeCode
    {
      // special handling for Actionable *until* API returns this in AmbitEventTypeCode instead of SURVEY for both
      this.NotificationTypeCode = Constants.NOTIFICATION_TYPE_SURVEY; 
    }
    else
    {
      this.NotificationTypeCode = notificationPayload.AmbitEventTypeCode; // ?? SURVEY | MONITOR | etc.
    }
    // useful for debugging
    //let SurveyPushString = JSON.stringify(SurveyPush);
    //console.log(SurveyPushString);
  }
}
